Shopify.queryParams = {};

// Preserve existing query parameters
if (location.search.length) {
	let params = location.search.substr(1).split('&');

	for (let index = 0; index < params.length; index++) {
		let keyValue = params[index].split('=');

		if (keyValue.length) {
			Shopify.queryParams[decodeURIComponent(keyValue[0])] = decodeURIComponent(keyValue[1].replace(/\+/g, ' '));
		}
	}
}

function refreshCollectionPageWithFilters(url_filters) {
  const url = new URL(window.location.href);
  const baseUrl = `${url.origin}${url.pathname}`;
  const queryParam = decodeURIComponent(url.searchParams.get('q')).split('?')[0]; // Décoder la valeur du paramètre 'q'

  // Construis l'URL finale avec les parties qui t'intéressent
  const currentUrl = `${baseUrl}?q=${encodeURIComponent(queryParam).replace(/%20/g, '+')}`; // Encoder le terme de recherche correctement

  let newPageString = httpGet(`${currentUrl}&${url_filters}`);

  let newPageEl = document.createElement("DIV");
  newPageEl.innerHTML = newPageString;

  var newSection = newPageEl.querySelector("#ProductGridContainer");

  document.querySelector("#ProductGridContainer").innerHTML = newSection.innerHTML;

  window.history.replaceState(null, document.title, `${currentUrl}&${url_filters}`);
  setTimeout(() => {
    checkForChanges();
  }, "0");
}

function httpGet(theUrl) {
	var xmlHttp = null;

	xmlHttp = new XMLHttpRequest();
	xmlHttp.open("GET", theUrl, false);
	xmlHttp.send(null);
	return xmlHttp.responseText;
}

function checkForChanges() {
  var form = document.getElementById("collectionFacetsForm");
  var inputs = form.querySelectorAll("input");

	inputs.forEach(function (input) {
    input.addEventListener("change", function (e) {
      fakeSubmitForm();
      // mmInitSplide();
		});
	});
}

document.querySelectorAll('.sort_by').forEach(function(select) {
	select.addEventListener('change', function (e) {
		var value = e.target.value;
		Shopify.queryParams.sort_by = value;
		location.search = new URLSearchParams(Shopify.queryParams).toString();
	});
});

function fakeSubmitForm() {
  let url_filters = $("#collectionFacetsForm").serialize();
	refreshCollectionPageWithFilters(url_filters);
}

// window.addEventListener("DOMContentLoaded", (event) => {
//   checkForChanges();
//   if (window.innerWidth < 900) {
//     mmCheckDrawer();
//   }
//   mmInitSplide();
// });


if (window.innerWidth < 900) {
  function mmOpenFiltersMobile() {
    var header = document.querySelector('header');
    var wrapperMobile = document.querySelector(".mm-filters-container");
    wrapperMobile.style.top = header.getBoundingClientRect().bottom + "px";
    wrapperMobile.style.height = "calc(var(--doc-height) - " + header.getBoundingClientRect().bottom + "px)";
		wrapperMobile.classList.add("mm-open");

		document.querySelector("html").classList.add("stop-scrolling");
	}
	function mmCloseFiltersMobile() {
		var wrapperMobile = document.querySelector(".mm-filters-container");
		wrapperMobile.classList.remove("mm-open");

		document.querySelector("html").classList.remove("stop-scrolling");
  }

  function mmCheckDrawer() {
    var currentUrl = document.location.href.indexOf("?open_filters");
    if (currentUrl !== -1) {
      mmOpenFiltersMobile();
    }
  }

}


